import Vue from "vue";
import {i18n} from "@/locale";
import store from "@/store/store";
import axios from "axios";
import "@/utils/publicImportMain";
import router from "./router"; // 路由
import webSocket from "@/utils/webSocket";
import {initPageConfig} from "@/utils/pageConfig";
import {getSaasParamKeysData, isReloadNavigation} from "@/utils/common";

localStorage.setItem('system', 'yms');
store.commit('system', 'yms');
import * as echarts from 'echarts';

Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$webSocket = webSocket;

initPageConfig('yms', ['ymsLogoConfig', 'ymsLanguage']).then(async (value) => {
  if (value) {
    // 仅在浏览器整页刷新时强制更新 SAAS 配置，路由切换时不重复请求
    if (isReloadNavigation()) {
      await getSaasParamKeysData(true);
    }
    new Vue({
      router,
      i18n,
      store, // 引入store配置
    }).$mount("#app");
  }
});
